"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOfUnsignedContracts = exports.accessId = void 0;
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
exports.accessId = '81e8ee67-11ac-47dc-9128-00fbdf0bf3c8';
const getNumberOfUnsignedContracts = async ({ accessId, groupKey, signerId, }) => {
    const { data } = await axios_1.default.get(`https://pactsafe.io/latest?sid=${accessId}&gkey=${groupKey}&sig=${encodeURIComponent(signerId)}`);
    const numberOfUnsignedContracts = lodash_1.default.filter(data, (contract) => !contract).length;
    return numberOfUnsignedContracts;
};
exports.getNumberOfUnsignedContracts = getNumberOfUnsignedContracts;
